import React from 'react'
import { SvgIcon } from '@material-ui/core'

function RestoreIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        id='Vector'
        d='M14.6 6.66667H18.6C18.9681 6.66667 19.2666 6.96515 19.2666 7.33333C19.2666 7.70152 18.9681 8 18.6 8H17.8633L16.8594 17.0348C16.6718 18.7229 15.245 20 13.5465 20H10.3201C8.62159 20 7.19471 18.7229 7.00714 17.0348L6.00327 8H5.26664C4.89846 8 4.59998 7.70152 4.59998 7.33333C4.59998 6.96515 4.89846 6.66667 5.26664 6.66667H9.26664C9.26664 5.19391 10.4605 4 11.9333 4C13.4061 4 14.6 5.19391 14.6 6.66667ZM11.9333 5.33333C11.1969 5.33333 10.6 5.93029 10.6 6.66667H13.2666C13.2666 5.93029 12.6697 5.33333 11.9333 5.33333ZM7.34482 8L8.33231 16.8875C8.44486 17.9004 9.30098 18.6667 10.3201 18.6667H13.5465C14.5656 18.6667 15.4217 17.9004 15.5342 16.8875L16.5218 8H7.34482Z'
      />
      <path
        id='Union'
        d='M11.5361 9.56496C11.7745 9.30935 12.1709 9.30935 12.4092 9.56496L14.4302 11.7324C14.6566 11.9751 14.6566 12.3598 14.4302 12.6025C14.1919 12.8581 13.7955 12.8581 13.5571 12.6025L12.5789 11.5535L12.579 16.373C12.579 16.6975 12.3284 16.9998 11.9727 16.9998C11.6169 16.9998 11.3664 16.6975 11.3664 16.3731L11.3663 11.5536L10.3882 12.6025C10.1499 12.8581 9.75344 12.8581 9.51509 12.6025C9.28878 12.3598 9.28878 11.9751 9.51509 11.7324L11.5361 9.56496Z'
      />
    </SvgIcon>
  )
}

export default RestoreIcon
